<script setup lang="ts">
const contactsStore = useMyContactsStore()
const { contacts } = storeToRefs(contactsStore)
</script>

<template>
  <section id="contact" class="bg-surface-2 p-6 md:p-9">
    <h2 class="text-center text-2xl font-extrabold md:text-3xl">تماس با من</h2>
    <p class="mx-auto mt-2.5 max-w-md text-center text-[13px] leading-8 text-muted">
      یک ایمیل کافی است؛ معمولاً در کمتر از یک روز پاسخ می‌دهم.
    </p>
    <ul class="mt-6 grid list-none gap-3 p-0 sm:grid-cols-2 lg:grid-cols-3">
      <li v-for="contact in contacts" :key="contact.id">
        <a
          :href="contact.href"
          :target="contact.external ? '_blank' : undefined"
          :rel="contact.external ? 'noopener noreferrer' : undefined"
          data-reveal
          class="flex items-center gap-3 bg-surface p-4 text-ink transition duration-300 hover:-translate-y-1 hover:shadow-[var(--t-glow)]"
        >
          <span class="grid h-[38px] w-[38px] shrink-0 place-content-center rounded-[10px] bg-[var(--t-accent-soft)] text-accent">
            <SharedContactIcon :kind="contact.icon" class="h-[18px] w-[18px]" />
          </span>
          <span class="grid min-w-0 gap-0.5">
            <span
              class="text-muted"
              :class="contact.displayValue ? 'text-[11px]' : 'text-[13px] font-bold'"
            >
              {{ contact.key }}
            </span>
            <span
              v-if="contact.displayValue"
              class="break-all text-[13px] font-bold truncate"
            >
              {{ contact.displayValue }}
            </span>
          </span>
        </a>
      </li>
    </ul>
  </section>
</template>
